module.exports = __webpack_public_path__ + "static/media/huli_303.cddd16ad.jpg";